<template>
  <div class="customer-list">
    <div class="search-box">
      <van-search
        v-model="filterData.searchKey"
        placeholder="请输入关键词进行搜索"
        show-action
        @cancel="cancel"
      />
      <van-field
        v-model="time"
        label="时间"
        size="large"
        readonly
        right-icon="arrow"
        input-align="right"
        placeholder="请选择时间"
        @click="isShowTiemModel = true"
      />
    </div>
    <refresh-list
      @onLoad="onLoad"
      :list="list"
      @onRefresh="init"
      ref="refreshList"
    >
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item
          :name="index"
          :is-link="false"
          v-for="(item, index) in list"
          :key="index"
        >
          <template #title>
            <div class="title">
              <div class="name">{{item.userName }}</div>
              <div class="title-left">
                <div class="number">
                  拉新：<span>{{item.missionNewPeople || 0}}</span>
                </div>
                <div class="number">
                  报名：<span>{{item.missionSignup || 0}}</span>
                </div>
              </div>
            </div>
          </template>
          <div class="content">
            <div class="list">
              <span class="list-left">角色</span>
              <span class="list-right">{{ item.roleName }}</span>
            </div>
            <div class="list">
              <span class="list-left">所属门店</span>
              <span class="list-right">{{ item.storeName }}</span>
            </div>
            <div class="list">
              <span class="list-left">所属经销商</span>
              <span class="list-right">{{ item.customerName }}</span>
            </div>
            <div class="list">
              <span class="list-left">拉新数</span>
              <span class="list-right">{{ item.missionNewPeople || 0 }}</span>
            </div>
            <div class="list">
              <span class="list-left">报名数</span>
              <span class="list-right">{{ item.missionSignup || 0 }}</span>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </refresh-list>
    <van-calendar
      ref="calendar"
      v-model="isShowTiemModel"
      color="#FF6B31"
      get-container="body"
      type="range"
      :default-date="defaultDateRange"
      :min-date="minDate"
      allow-same-day
      @confirm="hanldeTime"
    />
  </div>
</template>

<script>
import moment from "moment";
import refreshList from "@/components/refresh-list/refresh-list";
export default {
  components: {
    refreshList,
  },
  data() {
    return {
      filterData: {
        searchKey: ""
      },
      defaultDateRange: [],
      activeName: "1",
      list: [],
      pageNum: 1,
      pageSize: 20,
      isShowTiemModel: false,
      time: "",
      minDate: new Date(2021, 1, 1),
    };
  },
  watch: {
    "filterData.searchKey": {
      handler(value) {
        if (value) {
          this.init();
        }
      },
    },
  },
  computed: {
    parmes() {
      return this.$route.query
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    onLoad() {
      this.getList();
    },
    init() {
      this.pageNum = 1;
      this.list = [];
      this.getList();
    },
    hanldeTime(range) {
      const [start, end] = range;
      this.filterData.startTime = moment(start).format("YYYY-MM-DD") + ' 00:00:00';
      this.filterData.endTime = moment(end).format("YYYY-MM-DD") + ' 23:59:59';
      this.time = `${moment(this.filterData.startTime).format('M/D')}-${moment(this.filterData.endTime).format('M/D')}` 
      this.isShowTiemModel = false;
      this.init();
    },
    cancel() {
      this.$refs.calendar.reset()
      this.filterData = {}
      this.time = ""
      this.$refs["refreshList"].reset();
      this.init();
    },
    getList() {
      let data = {
        filterData: {...this.filterData, ...this.parmes},
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$api.h5
        .getActivityTaskDetails(data)
        .then((res) => {
          if (res.code == 200) {
            this.list.push(...res.data.list);
            this.pageNum = res.data.pageNum + 1;
            this.$refs["refreshList"].complete(res.data);
          } else {
            this.$refs["refreshList"].onFinish();
          }
        })
        .catch((err) => {
          this.$refs["refreshList"].onFinish();
        });
    },
  },
};
</script>
<style lang="stylus" scoped>
.customer-list {
  .search-box {
    background: #fff;
  }
  .van-pull-refresh {
    min-height: 100vh;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .name {
        color: #999999;
        font-size: 14px
      }
      .title-left {
        color: #333333;
        font-size: 14px;
      }
    }
    .content {
      .list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 44px;
        color: #999999;
        font-size: 14px;
        .list-right {
          display: flex;
          justify-content: flex-end;
          color: #333333;
          width: 270px;
        }
      }
    }
  }
}
</style>
